module.exports = __webpack_public_path__ + "static/img/acs@3x.ac8fc876.png";